import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { toast } from "react-toastify";
import AddEditInstructionModel from "./AddEditInstructionModel";

const Instructions = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [instructions, setInstructions] = useState([]);

  const handleIconClick = (index) => {
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const getAllInstructions = async () => {
    try {
      const response = null;
      if (response) {
        setInstructions(response);
      }
    } catch (error) {}
  };

  const deleteInstruction = async () => {
    try {
      if (window.confirm("Are you sure you want to delete instruction??")) {
        const response = null;
        if (response) {
          toast.success("Instruction deleted");
          getAllInstructions();
          setActiveIndex(null);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllInstructions();
  }, []);

  useEffect(() => {
    // getInstruction()
  }, [activeIndex]);

  return (
    <div className="container">
      <div className="overview d-flex justify-content-between align-items-center">
        <div className="title">
          <ion-icon name="alert-circle-outline"></ion-icon>
          <span className="text">Instructions</span>
        </div>

        <button
          className="btn-header d-flex align-items-center gap-1"
          data-bs-target="#uploadModal"
          data-bs-toggle="modal"
        >
          <ion-icon name="add-outline"></ion-icon>
          Add instruction
        </button>
      </div>

      <div className="data-table activityTable">
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th className="users-th">No</th>
                {/* <th className="users-th">Instruction No.</th> */}
                <th className="users-th">Instruction</th>
                <th className="users-th">Location</th>
                <th style={{ width: "30%" }} className="users-th">
                  Media
                </th>
                <th style={{ width: "10%" }} className="users-th">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {instructions?.map((instruction, index) => (
                <tr>
                  <td className="users-td" key={index}>
                    {index + 1}
                  </td>
                  {/* <td className="users-td">
                                        <div>{instruction.instructionNumber}</div>
                                    </td> */}
                  <td className="users-td">{instruction.title}</td>
                  <td className="users-td">
                    {instruction.locations}
                    {instruction.storyLocation?.map((item) => ` ${item} ,`)}
                  </td>
                  <td className="users-td">
                    {/* <img src={VIDEO} style={{ height: "50px" }} /> */}

                    <video width="200" height="200" controls>
                      <source
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </td>
                  <td className="users-td" style={{ width: "122px" }}>
                    <ion-icon
                      name="ellipsis-vertical-outline"
                      id="userAction"
                      onClick={() => handleIconClick(index)}
                      style={{ cursor: "pointer" }}
                    ></ion-icon>
                    {activeIndex === index && (
                      <div className="showOption-story">
                        <NavLink
                          to={`/view-instruction/${instruction._id}`}
                          className="removeTextDecoration"
                        >
                          <p className="pt-3 d-flex align-items-center gap-2">
                            <ion-icon name="eye-outline"></ion-icon> View
                          </p>
                        </NavLink>
                        <p
                          className="d-flex align-items-center gap-2"
                          data-bs-target="#editModal"
                          data-bs-toggle="modal"
                        >
                          <ion-icon name="create-outline"></ion-icon> Edit
                        </p>
                        <p
                          className="d-flex align-items-center gap-2"
                          style={{ color: "red" }}
                          onClick={deleteInstruction}
                        >
                          <ion-icon name="trash-outline"></ion-icon> Delete
                        </p>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Add */}
          <div
            className="modal fade"
            id="uploadModal"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel"
            tabIndex="-1"
          >
            <AddEditInstructionModel type="Add" />
          </div>

          {/* EDIT */}
          {activeIndex != null && (
            <div
              className="modal fade"
              id="editModal"
              aria-hidden="true"
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
            >
              <AddEditInstructionModel
                type="Edit"
                instructor={instructions[activeIndex]}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Instructions;
